(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialFileIbqDetailController', MaterialFileIbqDetailController);

    MaterialFileIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'MaterialFile', 'Material', 'PortalRole', 'Copyright'];

    function MaterialFileIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, MaterialFile, Material, PortalRole, Copyright) {
        var vm = this;

        vm.materialFile = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:materialFileUpdate', function(event, result) {
            vm.materialFile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
